import { InjectionToken } from '@angular/core';

export const MSSLIB_CONFIG = new InjectionToken<MssLibConfig>('msslib.config');

export interface MssLibConfig {
  applicationName: string;
}
